import p5 from "p5";

const p = (s) => {
	let slideShow;
	let font, cnv;

	/* ================= modified section: ================= */
	s.preload = () => {
		const distPath = import.meta.env.MODE.match(/(SERVE|STYLEGUIDE)/)
			? ""
			: "/frontend/dist/";
		font = s.loadFont(`${distPath}/assets/ABCGravity-expanded.woff`);
	};
	/* ============= end of modified section =============== */

	s.setup = () => {
		var div = s.drawingContext.canvas.parentElement;
		cnv = s.createCanvas(div.offsetWidth, div.offsetHeight);
		s.pixelDensity(window.devicePixelRatio);
		s.smooth();
		let slides = getDOMinfo();
		slideShow = new SlideShow(slides);
	};

	s.draw = () => {
		s.clear();
		let activeSlide = document.getElementsByClassName(
			"c-hero__caption--current"
		);

		slideShow.draw(activeSlide[0]);
	};

	s.windowResized = () => {
		setupCanvas();
		s.setup();
	};

	function getDOMinfo() {
		let slides = [];
		let htmlSlides = document.getElementsByClassName("c-hero__caption");

		for (let i = 0; i < htmlSlides.length; i++) {
			let tit = htmlSlides[i].children[1];
			let subTit = htmlSlides[i].children[0];

			let slide = {
				slide: htmlSlides[i],
				tit: tit,
				sub: subTit,
			};

			slide.boxes = [];
			slide.boxes[0] = slide.tit.getBoundingClientRect();
			slide.boxes[1] = slide.sub.getBoundingClientRect();

			var titSize = window
				.getComputedStyle(slide.tit, null)
				.getPropertyValue("padding-top");
			slide.boxes[0].y += parseFloat(titSize) - 10;
			slide.boxes[0].height -= parseFloat(titSize);
			slide.boxes[1].y -= 10;

			slide.sizes = [];
			var titSize = window
				.getComputedStyle(slide.tit, null)
				.getPropertyValue("font-size");
			slide.sizes[0] = parseFloat(titSize);

			var subSize = window
				.getComputedStyle(slide.sub, null)
				.getPropertyValue("font-size");
			slide.sizes[1] = parseFloat(subSize);

			slide.textLeading = [];
			var titLine = window
				.getComputedStyle(slide.tit, null)
				.getPropertyValue("line-height");
			slide.textLeading[0] = parseFloat(titLine);

			var subLine = window
				.getComputedStyle(slide.sub, null)
				.getPropertyValue("line-height");
			slide.textLeading[1] = parseFloat(subLine);

			slide.texts = [];
			slide.texts.push(slide.tit.innerText);
			slide.texts.push(slide.sub.innerText);

			// tit.style.display = "none";
			// subTit.style.display = "none";

			tit.style = "color: rgba(255, 255, 255, 0.0);"; // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< PAINTING ORIGINAL TEXT TRASNPARENT (SHOULD IT BE DONE ON THE CSS?)

			slides.push(slide);
		}
		return slides;
	}

	class SlideShow {
		constructor(slides) {
			this.lettering = [];
			this.slides = slides;

			for (let i = 0; i < this.slides.length; i++) {
				let l = new Lettering(this.slides[i]);
				this.lettering.push(l);
			}
		}

		draw(activeSlide) {
			for (let i = 0; i < this.lettering.length; i++) {
				this.lettering[i].draw(activeSlide);
			}
		}
	}

	class Lettering {
		constructor(slide) {
			this.on = false;
			this.animate = false;
			this.fired = 0;

			this.slide = slide;
			this.makeImage();

			let activeSlide = document.getElementsByClassName(
				"c-hero__caption--current"
			);
			this.on = activeSlide[0] == this.slide.slide;
			this.enter = !this.on;
			for (let i = 0; i < this.cutouts.length; i++) {
				this.cutouts[i].enter = this.enter;
				if (this.on) this.cutouts[i].scaleY = 1;
			}
			this.makeSubtitle();
		}

		makeImage() {
			let b = this.slide.boxes[0];
			let h = s.round(b.height * 1.2);
			let w = s.width;
			let yCenter = b.y - cnv.elt.getBoundingClientRect().y;

			this.originalImg = s.createGraphics(w, h);
			this.originalImg.pixelDensity(s.pixelDensity());
			this.originalImg.noStroke();
			this.originalImg.fill(255);
			this.originalImg.rectMode(s.CENTER);
			this.originalImg.textFont(font);
			this.originalImg.textSize(this.slide.sizes[0]);
			this.originalImg.textLeading(this.slide.textLeading[0]);
			this.originalImg.textAlign(s.CENTER, s.CENTER);

			let nLines = s.round(b.height / this.slide.textLeading[0]);
			if (nLines == 1) {
				this.originalImg.text(
					this.slide.texts[0],
					this.originalImg.width * 0.5,
					b.height * 0.48,
					b.width * 2,
					h
				);
			} else
				this.originalImg.text(
					this.slide.texts[0],
					this.originalImg.width * 0.5,
					b.height * 0.5,
					b.width + 25,
					h
				);

			this.cutouts = [];
			let hCut = s.round(this.slide.sizes[0] * 0.075);

			let movSize = this.slide.sizes[0] * 2;

			for (let y = 0; y < this.originalImg.height; y += hCut) {
				let cut = s.createImage(this.originalImg.width, hCut);
				cut.copy(
					this.originalImg,
					0,
					0,
					this.originalImg.width,
					this.originalImg.height,
					0,
					-y,
					this.originalImg.width,
					this.originalImg.height
				);
				let posCut = s.createVector(s.width * 0.5, y + hCut * 0.5 + yCenter);
				this.cutouts.push(new Cutout(cut, posCut, movSize));
			}
			this.originalImg.remove();
		}

		makeSubtitle() {
			let sub = new Subtitle(this.slide);
			sub.enter = this.enter;
			if (this.on) sub.alfa = 1;
			this.cutouts.push(sub);
		}

		checkAnimation() {
			for (let i = 0; i < this.cutouts.length; i++) {
				if (this.cutouts[i].animate) return true;
			}
			return false;
		}

		endAni() {
			this.animate = false;
		}

		pushLines() {
			this.cutouts[this.fired].startAni();
			if (this.fired < this.cutouts.length - 1) this.fired++;
			else this.endAni();
		}

		triggerAni(activeIsMe) {
			if (!this.checkAnimation()) {
				this.animate = true;
				this.on = !this.on;
				this.fired = 0;
			} else {
				this.on = activeIsMe;
				this.animate = true;
				this.fired = 0;
				for (let i = 0; i < this.cutouts.length; i++) {
					this.cutouts[i].forceOut();
				}
			}
		}

		checkActive(active) {
			let activeIsMe = active == this.slide.slide;
			if (this.on != activeIsMe) this.triggerAni(activeIsMe);
		}

		draw(activeSlide) {
			this.checkActive(activeSlide);
			if (this.animate) this.pushLines();
			let animating = this.animate || this.checkAnimation();
			if (this.on || animating) {
				for (let i = 0; i < this.cutouts.length; i++) {
					this.cutouts[i].draw();
				}
			}
		}
	}

	class Subtitle {
		constructor(slide) {
			this.slide = slide;
			this.text = slide.texts[1];
			this.pos0 = s.createVector(
				s.width * 0.5 - slide.boxes[1].width * 0.5,
				slide.boxes[1].y -
				cnv.elt.getBoundingClientRect().top +
				slide.boxes[1].height * 0.5
			);

			this.pos = this.pos0.copy();
			this.enter = true;
			this.animate = false;
			this.aniDuration = 10;
			this.aniTime = 0;
			this.distance = slide.textLeading[1];
			this.displace = s.createVector(0, 0);
			this.alfa = 0;
			this.delay0 = 0;
			this.delay = 30 + this.aniDuration + 5;
		}

		endAni(active = null) {
			this.aniTime = 0;
			this.animate = false;

			if (active == null) this.enter = !this.enter;
			else this.enter = !active;

			if (this.enter) this.alfa = 0;
			else this.alfa = 1;
		}

		startAni() {
			this.animate = true;

			if (this.enter) {
				let d = this.distance;

				this.displace = s.createVector(0, d);
				this.displace.add(this.pos0);

				this.pos = this.displace.copy();
			} else {
				let d = -this.distance;

				this.displace = s.createVector(0, d);
				this.displace.add(this.pos);
			}
		}

		reset() {
			this.enter = true;
			this.animate = false;
			this.aniTime = 0;
		}

		forceOut() {
			this.aniTime = 0;
			this.enter = false;
			this.animate = false;
		}

		move() {
			let aniTime = this.aniTime;

			if (this.enter) {
				aniTime -= this.delay;
				aniTime = s.max(aniTime, 0);
			} else {
				aniTime -= this.delay0;
				aniTime = s.max(aniTime, 0);
			}

			let p = s.norm(aniTime, 0, this.aniDuration);

			if (this.enter) {
				this.pos = p5.Vector.lerp(this.displace, this.pos0, p);
				this.alfa = p; //s.map(p, 0, 1, 0, 1, true)
			} else {
				this.alfa = s.map(p, 0, 1, 1, 0, true);
				this.pos = p5.Vector.lerp(this.pos0, this.displace, p);
			}

			if (aniTime < this.aniDuration) this.aniTime++;
			else this.endAni();
		}

		draw() {
			if (this.animate) this.move();

			if (this.alfa > 0) {
				s.push();
				s.translate(this.pos.x, this.pos.y);
				s.noStroke();
				s.fill(255, this.alfa * 255);
				// let b = this.slide.boxes[1]
				// s.textFont(font)
				// s.textSize(this.slide.sizes[1])
				// s.textAlign(s.LEFT, s.TOP)
				// s.text(this.text, 0, 0, b.width * 2, b.height * 1.1)
				// s.pop()
			}
		}
	}

	class Cutout {
		constructor(img, pos0, movSize) {
			this.img = img;
			this.pos0 = pos0.copy();
			this.pos = pos0.copy();
			this.enter = true;
			this.animate = false;
			this.aniDuration = 45;
			this.aniTime = 0;
			this.distance = movSize;
			this.displace = s.createVector(0, 0);
			this.angle = 0;
			this.maxAngle = s.PI * 0.05;
			this.scaleY = 0;
		}

		endAni(active = null) {
			this.aniTime = 0;
			this.animate = false;

			if (active == null) this.enter = !this.enter;
			else this.enter = !active;

			if (this.enter) this.scaleY = 0;
			else this.scaleY = 1;
		}

		startAni() {
			this.animate = true;
			let d = this.distance * 2;
			if (!this.enter) d = -this.distance;
			this.displace = s.createVector(0, d);
			this.displace.add(this.pos0);
			if (this.enter) this.pos = this.displace.copy();
		}

		reset() {
			this.enter = true;
			this.animate = false;
			this.aniTime = 0;
		}

		forceOut() {
			this.aniTime = 0;
			this.enter = false;
			this.animate = false;
		}

		move() {
			let aniTime = this.aniTime;

			if (this.enter) {
				let delay = this.aniDuration * 0.75;
				aniTime -= delay;
				aniTime = s.max(aniTime, 0);
			}
			let p = s.norm(aniTime, 0, this.aniDuration);
			let pIn = easeIn(p);
			let pOut = easeOut(p);

			if (this.enter) {
				this.pos = p5.Vector.lerp(this.displace, this.pos0, pOut);
				this.scaleY = pOut;
				this.angle = (1 - pOut) * this.maxAngle;
			} else {
				this.pos = p5.Vector.lerp(this.pos0, this.displace, pIn);
				this.scaleY = 1 - pIn;
				this.angle = pIn * this.maxAngle;
			}

			if (aniTime < this.aniDuration) this.aniTime++;
			else this.endAni();
		}

		draw() {
			s.noFill();
			if (this.animate) this.move();
			if (this.scaleY > 0) {
				s.push();
				s.translate(this.pos.x, this.pos.y);
				s.rotate(this.angle);
				s.scale(1, this.scaleY);
				s.translate(-this.img.width * 0.5, -this.img.height * 0.5);
				s.image(this.img, 0, 0, this.img.width, this.img.height);
				s.pop();
			}
		}
	}

	function easeOut(x) {
		return 1 - s.pow(1 - x, 3);
	}

	function easeIn(x) {
		return x * x * x;
	}
};

let d = document.getElementsByClassName("c-hero__caption-container");
let c = document.getElementsByClassName("c-hero__caption");
let skch;

if (d.length > 0) {
	const newDiv = document.createElement("div");
	newDiv.id = "carousel-lettering";
	d[0].appendChild(newDiv);

	window.addEventListener("load", function() {
		setupCanvas();
		skch = new p5(p, "carousel-lettering");
	});
}

function setupCanvas() {
	let biggest;
	for (let i = 0; i < c.length; i++) {
		if (biggest == null) biggest = c[i];
		else if (c[i].children[1].offsetHeight > biggest.children[1].offsetHeight)
			biggest = c[i];
	}
	let h = biggest.children[1].offsetHeight * 4;

	let sketchDiv = document.getElementById("carousel-lettering");
	sketchDiv.style =
		"height: " +
		h +
		"px; width: " +
		biggest.children[1].offsetWidth +
		"px;" +
		"position: absolute; top: " +
		(biggest.children[1].getBoundingClientRect().top -
			biggest.getBoundingClientRect().top +
			100 +
			biggest.children[1].offsetHeight * 0.5 -
			h * 0.5) +
		"px; left: calc(50vw - " + (biggest.children[1].offsetWidth / 2) + "px); z-index: -1;";
}
